import {Timestamp} from '@angular/fire/firestore';

//#region INTERFACE IAutoOrderAccountSettings
export interface IAutoOrderAccountSettings {
  growth: number;
  monthsHistory: number;
  period: number;
  stockDays: number;
  day?: string;
  modifiedDate?: Timestamp;
  repeat?: string;
  startDate?: Date;
  userId?: string;
}

//#endregion